import React from 'react'
import { ITicket } from '@api'

export default function TicketNumber({ ticket, style }: { ticket: ITicket; style?: any }) {
  if (!ticket.ticketNumber) return null

  return ticket.source === 'spaceiq' ? (
    <span style={{ color: 'var(--grey1)', ...style }}>{ticket.ticketNumber}</span>
  ) : (
    <a
      style={{ color: 'var(--primary-color)', ...style }}
      href={ticket.externalUrl as string}
      target="_blank"
      rel="noopener noreferrer"
    >
      {ticket.ticketNumber}
    </a>
  )
}
